
import { onClickOutside } from '~/directives/onClickOutside';

export default {
  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    video: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      changes: {
        url: '',
        title: '',
      },
    };
  },

  mounted() {
    this.changes = {
      url: this.video?.url || '',
      title: this.video?.title || '',
    };
  },

  methods: {
    onInputChange() {
      this.onChange(this.changes);
    },
  },
};
